import { ProductPriceData } from "@domain/product/product-price-data";
import { ProductListDiscountKey } from "@domain/project/product-list/product-list-discount-key.util";
import { Exclude, Type } from "class-transformer";
import { IsOptional, IsString, ValidateNested } from "class-validator";

export class PlaceholderProduct {
  @IsString()
  name: string;

  @IsString()
  id: string;

  @IsString()
  positionId: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => ProductPriceData)
  price?: ProductPriceData;

  @Exclude()
  discountKey?: ProductListDiscountKey;

  @Exclude()
  discount: number = 0;

  constructor(name: string, id: string, positionId: string = "", price?: ProductPriceData) {
    this.name = name;
    this.id = id;
    this.positionId = positionId;
    this.price = price;
  }

  copy() {
    return new PlaceholderProduct(this.name, this.id, this.positionId, this.price);
  }
}
